<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-2">
                        <az-input   
                            v-if="filtro.tipo_referencia == 'D'"
                            type="date"
                            v-model="filtro.referencia">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load()">
                                        <i class="fas fa-sync-alt fa-fw"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input   
                            v-else-if="filtro.tipo_referencia == 'M' || filtro.tipo_referencia == 'EM'"
                            type="month"
                            v-model="filtro.ref_mes">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load()">
                                        <i class="fas fa-sync-alt fa-fw"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input   
                            v-else-if="filtro.tipo_referencia == 'S'"
                            type="week"
                            v-model="filtro.ref_semana">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load()">
                                        <i class="fas fa-sync-alt fa-fw"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input   
                            type="select"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            icon="fa fa-building-o fa-fw"
                            placeholder="Unidades..."
                            v-model="filtro.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-filter fa-fw"
                            type="select"
                            placeholder="Todos os Centros de Custo..."
                            :optionsList="lista_centros_filtro"
                            optionsData="id_centro_custo"
                            :edicao="lista_centros_filtro.length ? true : false"
                            v-model="filtro.id_centro_custo" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Todos os Usuários..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="usuarios.index" 
                            optionsName="filtro-usuarios"
                            :optionsParm="{ where: { fl_ativo: true } }"
                            :optionsSync="false"
                            v-model="filtro.usuario">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon1" 
                                        @click="filtro.usuario ? ( filtro.usuario = null ) : ( filtro.usuario = $store.state.user )">
                                        <i class="fa fa-user fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input 
                            type="checkbox-group"
                            label="Externo"
                            v-model="filtro.externo" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input 
                            placeholder="Todos os Locais..."
                            icon="fas fa-clinic-medical fa-fw"
                            type="select"
                            optionsMode="aql"
                            service="centro_cirurgicos.index"
                            optionsData="id_centro_cirurgico" 
                            optionsDisplay="st_centro_cirurgico"
                            :optionsParm="{ ativos: true }"
                            :edicao="filtro.externo"
                            v-model="filtro.id_centro_cirurgico"  />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input icon="fa fa-search fa-fw" v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="incluir()" title="Registrar Admissão" v-if="filtro.interno">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>

                                    <print-export printid="lista-impressao" />
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="row mt-2">

                    <div class="col col-12 d-flex flex-column">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'D', search: 'Diário' },
                                { id: 'S', search: 'Semanal' },
                                { id: 'M', search: 'Mensal' },
                                { id: 'EM', search: 'Escala Mensal' },
                            ]" 
                            v-model="filtro.tipo_referencia"
                            @input="load()" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>    

        <escala-movimentacoes ref="mov" @refresh="load()"/>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum escala identificada.'" 
                icon="fas fa-calendar-day" />
		</div>

        <div v-if="!em_edicao && lista && lista.length" id="lista-impressao">

            <cabecalho-generico titulo="Escalas">
                <div v-if="base.id_centro_cirurgico">
                    {{ lista[0].centro.search }}
                </div>    
                <div v-if="filtro.search">
                    <i class="fas fa-search mr-2"></i>
                    {{ filtro.search }}
                </div>
            </cabecalho-generico>

            <!-- Alocações com Visão Mensal... -->

            <template v-if="base && ( base.tipo_referencia == 'EM' )">

                <div>

                    <p class="alert alert-info">{{ $util.getFormatDate(filtro_selecionado.ref_mes, 'MMMM [de] YYYY') }}</p>

                    <p v-if="!base.id_centro_cirurgico" class="alert alert-warning">Selecione o Local.</p>

                    <table class="table table-sm table-bordered table-striped cabecalho-fixo" v-else>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th v-for="dia in last_day" :key="dia" class="text-center">
                                    {{ $util.getFormatDate(filtro_selecionado.ref_mes + '-' + dia, 'ddd').substr(0,1) }}<br>
                                    {{ dia }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(alocacoes, id, iax) in lista_resumo">
                                <tr :key="iax" class="table-info">
                                    <td colspan="32">{{ alocacoes[0].tipo.search }}</td>
                                </tr>
                                <tr v-for="(useralocs, username, iux) in lista_alocacoes_por_usuario(alocacoes)" :key="iax + '-' + iux" class="small text-nowrap">
                                    <td>{{ username }}
                                        <span v-if="useralocs[0].usuario.medico && useralocs[0].usuario.medico.conselho" class="ml-3">
                                            {{ useralocs[0].usuario.medico.conselho.st_sigla }}
                                            {{ useralocs[0].usuario.medico.in_numero_conselho }}
                                        </span>
                                    </td>
                                    <td v-for="dia in last_day" :key="dia" class="text-center">
                                        {{ tem_alocacao_no_dia(useralocs, dia) }}
                                    </td>
                                    <td colspan="31" v-if="false">
                                        <pre>{{ useralocs }}</pre>
                                    </td>
                                </tr>
                            </template>
                        </tbody>

                    </table>

                </div>

            </template>


            <!-- Alocações com Visão Mensal... -->

            <template v-if="base && ( base.tipo_referencia == 'M' )">

                <p class="alert alert-info">{{ $util.getFormatDate(filtro_selecionado.ref_mes, 'MMMM [de] YYYY') }}</p>

                <div class="card">
                    <table class="table table-sm mb-0">
                        <thead>
                            <tr v-for="(semana, isx) in lista[0].dias" :key="isx">
                                <template v-if="semana[0].dw != 1">
                                    <td v-for="(antes, iax) in 7 - semana.length" :key="'A' + iax">
                                        &nbsp;
                                    </td>
                                </template>
                                <td v-for="(dia, idx) in semana" :key="idx" class="p-0" width="14.28%">
                                    <div class="card mb-0">
                                        <div class="card-header small text-muted d-flex justify-content-between">
                                            <div>{{ dia.df.substr(0,2) }}</div>
                                            <div>{{ nome_dia(dia.dw) }}</div>
                                        </div>
                                        <div class="card-body">
                                            <template v-for="(aloc, iax) in mensal_alocacao_data(isx, idx)">
                                                <div :key="iax" v-if="( !aloc.por_usuario || aloc.alocacao.length ) && ( aloc.alocacao.length || aloc.qtd )">
                                                    <span class="badge" v-if="!aloc.por_usuario"
                                                        :class="aloc.alocacao.length == 0 ? 'badge-danger'
                                                            : ( aloc.alocacao.length < aloc.qtd ? 'badge-warning' : 'badge-success' )">
                                                        {{ aloc.alocacao.length }}/{{ aloc.qtd }}
                                                    </span>
                                                    <a href="#" @click.prevent="consultar_alocados(aloc)" class="card-link">
                                                        <span class="small">
                                                            {{ aloc.local }}
                                                            <span class="text-muted">
                                                                {{ aloc.search }}
                                                            </span>
                                                        </span>
                                                    </a>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                    </table>
                </div>
            </template>

            <!-- Alocações com Visão Semanal ou Intervalada... -->

            <template v-if="base && base.tipo_referencia == 'S'">

                <div class="card">
                    <table class="table mb-0 cabecalho-fixo">
                        <thead>
                            <tr>
                                <th>Escala</th>
                                <th v-for="(dia, idx) in lista[0].dias" :key="idx">
                                    {{ dia.df }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dado, id) in lista" :key="id">
                                <td width="30%">
                                    <div class="small">{{ dado.centro.st_centro_cirurgico }}</div>
                                    <div>{{ dado.search }}</div>
                                    <div class="small text-muted">
                                        {{ dado.hr_inicio }} - {{ dado.hr_termino }}
                                        <i class="fas fa-stopwatch ml-3"></i>
                                        {{ dado.duracao }}h
                                    </div>
                                </td>
                                <td v-for="(dia, idx) in dado.dias" :key="idx" width="10%">
                                    <div v-for="(alocacao, iux) in dia.alocacao" :key="iux">
                                        <i class="fa fa-check-circle text-primary mr-1" aria-hidden="true" v-if="alocacao.hr_inicio && alocacao.hr_termino" title="Escala Realizada"></i>
                                        <i class="fa fa-check-circle text-success mr-1" aria-hidden="true" v-else-if="alocacao.hr_inicio" title="Check-In Realizado"></i>
                                        <i class="fas fa-circle" v-else :class="alocacao.dt_escala <= $util.hoje() ? 'text-warning' : 'text-muted'" title="Escala em Aberto"></i>
                                        {{ alocacao.usuario.st_login }}
                                    </div>
                                    <div v-if="dia.vagas" class="text-danger">
                                        <i class="fa fa-exclamation-triangle mr-1" aria-hidden="true"></i>
                                        {{ dia.vagas }} {{ dia.vagas > 1 ? 'vagas' : 'vaga' }}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </template>

            <!-- Alocações com Visão Diária... -->

            <template v-else-if="base && base.tipo_referencia == 'D'">

                <p class="alert alert-info">{{ $util.getFormatDate(filtro_selecionado.referencia, 'DD/MM/YYYY') }}</p>

                <div class="card" v-for="(dado, id) in lista" :key="id">
                    <div class="card-header">
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            <span v-if="dado.tipo.fl_externo && dado.centro">
                                {{ dado.centro.st_centro_cirurgico }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            </span>
                            {{ dado.search }}
                            <span v-if="dado.centro_custo">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ dado.centro_custo.st_nome }}
                            </span>
                        </a>
                        <small v-if="dado.unidade_operacao && dado.unidade_operacao.st_sigla" class="badge badge-light mx-1">
                            {{ dado.unidade_operacao.st_sigla }}
                        </small>
                        <div class="small text-muted">
                            {{ dado.hr_inicio }} - {{ dado.hr_termino }}
                            <i class="fas fa-stopwatch ml-3"></i>
                            {{ dado.duracao }}h
                        </div>
                    </div>
                    <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between" v-for="(alocacao, iux) in dado.alocacao" :key="iux">
                            <div>
                                {{ alocacao.usuario.pessoa.st_nome }}

                                <a href="#" @click.prevent="abrir_repeticao(alocacao)" v-if="alocacao.fl_base && alocacao.id_plantao_repeticao" title="Repetição">
                                    <i class="fas fa-sync ml-2"></i>
                                </a>
                                
                                <i class="fas fa-exchange-alt ml-2" v-if="alocacao.id_plantao_escala_origem"></i>

                                <div v-if="alocacao.hr_inicio">
                                    <i class="fa fa-check-circle mx-2" :class="alocacao.hr_termino ? 'text-primary' : 'text-success'" aria-hidden="true"></i>
                                    <span title="check-in">{{ alocacao.hr_inicio.substr(0,5) }}</span>
                                    <span title="check-out" class="ml-1" v-if="alocacao.hr_termino">- {{ alocacao.hr_termino.substr(0,5) }}</span>
                                </div>

                                <div v-if="alocacao.movimentacao" class="small text-danger">
                                    <i class="fas fa-exclamation-triangle mx-2"></i>
                                    <span v-if="alocacao.movimentacao.ch_tipo_movimentacao == 'T'">
                                        <a href="#" @click.prevent="editar_troca(alocacao, dado)" class="card-link">
                                            Troca Solicitada
                                        </a>
                                    </span>

                                    <span v-if="alocacao.movimentacao.ch_tipo_movimentacao == 'V'">
                                        <a href="#" @click.prevent="editar_venda(alocacao, dado)" class="card-link">
                                            Venda Anunciada
                                        </a>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <button type="button" class="btn btn-outline-primary" @click="trocar(alocacao, dado)" title="Trocar" v-if="!alocacao.movimentacao && alocacao.id_usuario == $store.state.user.id_usuario">
                                    <i class="fas fa-exchange-alt fa-fw"></i>
                                </button>
                                <button type="button" class="btn btn-outline-primary ml-1" @click="vender(alocacao, dado)" title="Vender" v-if="!alocacao.movimentacao && alocacao.id_usuario == $store.state.user.id_usuario">
                                    <i class="fas fa-hand-holding-usd"></i>
                                </button>
                                <button type="button" class="btn btn-outline-danger ml-1" @click="cancelar_escala(alocacao)" title="Remover" v-if="dado.gestao_escalas !== false">
                                    <i class="fa fa-trash-o fa-fw" aria-hidden="true"></i>
                                </button>
                            </div>
                        </li>
                    </ul>
                    <div class="card-body alert-danger d-flex justify-content-between" v-if="dado.vagas">
                        <div>
                            {{ dado.vagas }} {{ dado.vagas > 1 ? 'Alocações Pendentes' : 'Alocação Pendente' }}
                        </div>
                        <div>
                            <button type="button" class="btn btn-primary" @click="alocar(dado)" v-if="dado.gestao_escalas !== false">
                                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>

            </template>
        </div>

        <!-- Modal para Fazer Alocação -->
        <div class="modal fade" id="alocacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="agenda">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Alocação
                            <span v-if="agenda.tipo.fl_externo && agenda.centro">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ agenda.centro.search }}
                            </span>
                        </h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ agenda.tipo.search }}
                            <div class="small text-muted"> 
                                {{ agenda.hr_inicio }} 
                                <i class="fa fa-caret-right mx-1" aria-hidden="true"></i>
                                {{ agenda.hr_termino }}
                            </div>
                            <div class="small text-muted" v-if="agenda.centro_custo" title="Centro de Custo">
                                {{ agenda.centro_custo.search }}
                            </div>
                        </div>

                        <template v-if="item.usuarios">
                            <template v-for="(usuario, iux) in item.usuarios">
                                <az-input
                                    v-show="!usuario.excluido"
                                    :key="iux"
                                    :edicao="false"
                                    v-model="usuario.pessoa.search">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="usuario.excluido = true">
                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </template>
                        </template>

                        <az-input
                            icon="fa fa-plus"
                            placeholder="Selecione o Profissional..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="usuarios.index" 
                            optionsName="filtro-usuarios"
                            :edicao="usuarios_selecionados < agenda.vagas"
                            :optionsParm="{ where: { fl_ativo: true } }"
                            :optionsSync="false"
                            v-model="novo_usuario" 
                            @input="incluir_usuario()" />

                        <hr>

                        <az-input 
                            type="button-group"
                            :optionsList="[
                                { id: 'N', search: 'Não Repetir' },
                                { id: 'S', search: 'Semanal' },
                                { id: 'I', search: 'Intervalo' },
                            ]"
                            optionsData="id"
                            v-model="item.repeticao" />

                        <!-- Seleção da Repetição da Alocação -->

                        <template v-if="item.repeticao == 'S' || item.repeticao == 'I'">

                            <template v-if="item.repeticao == 'S'">

                                <div class="row mt-3" v-if="item.js_dias_da_semana">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            label="Repetir a cada"
                                            type="number"
                                            v-model="item.repetir.intervalo">
                                            <template v-slot:button-pos>
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon2">
                                                        {{ dados.intervalo > 1 ? 'semanas' : 'semana' }}
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>                   
                                    </div>
                                    <div class="col col-12 d-flex flex-column col-md-8">
                                        <small class="text-muted">Repetir</small>
                                        <div class="btn-group" role="group">
                                            <template v-for="(dia, idia) in item.js_dias_da_semana">
                                                <button type="button" class="btn" 
                                                    :class="dia ? 'btn-secondary' : 'btn-outline-secondary'" 
                                                    v-show="dia !== null"
                                                    @click="toggle_dia(idia)" :key="idia">
                                                    {{ nome_dia(idia) }}
                                                    <i class="fa fa-check ml-2" v-if="dia" aria-hidden="true"></i>
                                                    <i class="fa fa-times ml-2" v-else aria-hidden="true"></i>
                                                </button>
                                            </template>
                                        </div>
                                    </div>
                                </div>

                            </template>

                            <template v-else>
                                <div class="row mt-3" v-if="item.repetir">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            label="Repetir a cada"
                                            type="number"
                                            v-model="item.repetir.intervalo">
                                            <template v-slot:button-pos>
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon2">
                                                        {{ dados.intervalo > 1 ? 'dias' : 'dia' }}
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>                   
                                    </div>
                                </div>
                            </template>

                            <div class="row mt-3">
                                <div class="col col-12 col-md-4">
                                    <small class="text-muted">Terminar em</small>
                                    <az-input
                                        type="date"
                                        v-model="item.repetir.termina_em"
                                        :edicao="item.repetir.fim == 'em'">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">
                                                    <input type="radio" v-model="item.repetir.fim" value="em">
                                                    <span class="ml-2">Em &nbsp;&nbsp;</span>
                                                </div>
                                            </div>
                                        </template>
                                    </az-input>
                                    <az-input
                                        type="number"
                                        :max="30"
                                        :maxlength="2"
                                        v-model="item.repetir.ocorrencias"
                                        :edicao="item.repetir.fim == 'apos'">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">
                                                    <input type="radio" v-model="item.repetir.fim" value="apos">
                                                    <span class="ml-2">Após</span>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-slot:button-pos>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    {{ item.repetir.ocorrencias > 1 ? 'ocorrências' : 'ocorrência' }}
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-8">
                                    <small class="text-muted">Datas</small>
                                    <div class="alert alert-primary">
                                        <div class="row">
                                            <div class="col col-12 col-md-3" v-for="(dt, idx) in calc_datas()" :key="idx">
                                                {{ $util.getFormatDate(dt) }}
                                                <span class="badge badge-secondary">
                                                    {{ $util.getFormatDate(dt, 'ddd') }}
                                                </span>
                                                <span class="ml-1" v-if="false && item.valid">
                                                    <a href="#" @click.prevent="toggleValid(dt)" v-if="item.valid[dt] === 'S'">
                                                        <i class="fas fa-check-circle text-success"></i>
                                                    </a>
                                                    <a href="#" @click.prevent="toggleValid(dt)" v-if="item.valid[dt] === 'B'">
                                                        <i class="fa fa-minus-circle text-secondary"></i>
                                                    </a>
                                                    <i class="fa fa-times-circle text-danger" v-if="item.valid[dt] === 'N'"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </template>

                        <pre v-if="false">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_alocacao ()">Alocar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para Consultar Alocação -->
        <div class="modal fade" id="alocadosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="alocados">
                    <div class="modal-header">
                        <h5 class="modal-title">Alocados</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            <div>{{ alocados.local }}</div>
                            <div>{{ alocados.search }}</div>
                            <div>{{ $util.getFormatDate(alocados.data) }}</div>
                        </div>

                        <div class="badge h5" :class="alocados.vagas == alocados.qtd 
                            ? 'badge-danger'
                            : ( alocados.vagas == 0 ? 'badge-success' : 'badge-warning' )">
                            {{ alocados.qtd - alocados.vagas }}/{{ alocados.qtd }}
                        </div>

                        <ul class="list-group">
                            <li class="list-group-item" v-for="(alocado, iux) in alocados.alocacao" :key="iux">
                                {{ alocado.usuario.pessoa.st_nome }}
                            </li>
                        </ul>

                        <pre v-if="false">{{ alocados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_plantao_agenda ? '' : 'Novo' }}
                            Escala
                            <span class="badge badge-secondary" v-if="item && item.id_plantao_agenda">
                                #{{ item.id_plantao_agenda }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Unidade"
                                    type="select"
                                    :edicao="!item.id_plantao_agenda"
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    optionsData="id_unidade_operacao"
                                    required
                                    :validate="validate"
                                    v-model="item.id_unidade_operacao" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Tipo"
                                    type="select"
                                    optionsMode="aql"
                                    service="plantao_tipos.index"
                                    optionsData="id_plantao_tipo"
                                    :edicao="!item.id_plantao_agenda"
                                    required
                                    :validate="validate"
                                    v-model="item.id_plantao_tipo"
                                    @input="atualizar_tipo()">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.tipo">
                                            <span class="input-group-text" :class="item.tipo.st_color ? 'text-' + item.tipo.st_color : ''" id="basic-addon2">
                                                <i class="fa fa-building-o" v-if="!item.tipo.fl_externo"></i>
                                                <i class="fas fa-external-link-alt" v-else></i>
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Quantidade"
                                    type="number"
                                    required
                                    :validate="validate"
                                    v-model="item.in_necessidade" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    :type="trocando_valor ? 'number' : 'money'"
                                    label="Valor Padrão"
                                    v-model="item.dc_valor_plantao" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Local"
                                    type="select"
                                    optionsMode="aql"
                                    service="centro_cirurgicos.index"
                                    optionsData="id_centro_cirurgico"
                                    :edicao="!item.id_plantao_agenda"
                                    required
                                    :validate="validate"
                                    v-model="item.id_centro_cirurgico" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Início da Vigência"
                                    type="date"
                                    required
                                    :validate="validate"
                                    v-model="item.dt_vigencia_inicio" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Término da Vigência"
                                    type="date"
                                    required
                                    :validate="validate"
                                    v-model="item.dt_vigencia_fim" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Horário de Entrada"
                                    type="time"
                                    required
                                    :validate="validate"
                                    v-model="item.hr_inicio" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Horário de Saída"
                                    type="time"
                                    required
                                    :validate="validate"
                                    v-model="item.hr_termino" />
                            </div>
                        </div>

                        <div class="row" v-if="item.js_dias_da_semana">
                            <div class="col col-12 d-flex flex-column">
                                <div class="btn-group input-group-sm mt-2 mb-2" role="group" aria-label="Basic example">
                                    <button type="button" class="btn" 
                                        :class="dia ? 'btn-secondary' : 'btn-outline-secondary'" 
                                        @click="toggle_dia(idia)"
                                        v-for="(dia, idia) in item.js_dias_da_semana" :key="idia">
                                        {{ nome_dia(idia) }}
                                        <i class="fa fa-check ml-2" v-if="dia" aria-hidden="true"></i>
                                        <i class="fa fa-times ml-2" v-else aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="textarea"
                                    rows="3"
                                    label="Observação"
                                    :validate="validate"
                                    v-model="item.st_obs" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-sub-title class="mt-1" title="Classificação Requerida" />
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="plantaoAgenda" :id="item.id_plantao_agenda" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_plantao_agenda ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Motivo Cancalemento -->
        <div class="modal fade" id="cancelarEscalaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="item_cancelar">
                    <div class="modal-header">
                        <h5 class="modal-title">Cancelamento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-info">
                            {{ item_cancelar.usuario.search }}
                        </p>

                        <az-input
                            label="Motivo"
                            type="textarea"
                            rows="5"
                            required
                            :validate="validate"
                            v-model="motivo" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit color="danger" @click="salvar_cancelamento_escala()">Cancelar Escala</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <escala-troca ref="troca" @refresh="load()" />
        <escala-venda ref="venda" @refresh="load()" />
        <escala-repeticao ref="repet" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Multiselect from 'vue-multiselect';
import EscalaTroca from './EscalaTroca.vue';
import EscalaVenda from './EscalaVenda.vue';
import EscalaMovimentacoes from './EscalaMovimentacoes.vue';
import EscalaRepeticao from './EscalaRepeticao.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            item_cancelar: null, 
            validate: false,
            motivo: "", 
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            options_classes: [],
            trocando_valor: false, 
            filtro: { 
                id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'), 
                id_centro_custo: "", 
                search: "",
                referencia: this.$util.hoje(), 
                ref_semana: "",
                ref_mes: this.$util.hoje().substr(0,7),
                externo: true, 
                id_centro_cirurgico: "", 
                tipo_referencia: 'D',
            }, 
            agenda: null, 
            novo_usuario: "", 
            base: null, 
            alocados: null, 
            filtro_selecionado: null, 
        }
    },

    props: ['local'],

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        AzSubTitle,
        Multiselect,
        EscalaTroca,
        EscalaVenda,
        EscalaMovimentacoes, 
        EscalaRepeticao,
        PrintExport, 
        CabecalhoGenerico, 
    },

    computed: { 
        lista_centros_filtro: function () { 
            
            if ( !this.filtro || !this.filtro.id_unidade_operacao ) 
                return [];

            let und = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.filtro.id_unidade_operacao);

            return und ? und.centro_custos : [];

        },

        usuarios_selecionados: function () { 
            if ( !this.item || !this.item.usuarios )
                return 0;

            return this.item.usuarios.filter(item => !item.excluido).length;
        },

        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.filtro.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.filtro.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_resumo: function () { 
            return _.groupBy(this.lista, 'tipo.search');
        },

        last_day: function () { 
            return parseInt(this.$util.ultimo_dia_mes(this.filtro_selecionado.ref_mes).substr(8,2));
        }

    },

    methods: { 
        tem_alocacao_no_dia (lista, dia) { 
            let horario = lista.filter(item => item.dt_escala.substr(8,2) == dia)
                .map((aloc) => { 
                    let horario = aloc ? aloc.horario : '-';

                    let horas = horario.split('-');

                    if ( horas.length == 2 ) { 
                        if ( horas[0] >= 7 && horas[0] <= 13 && horas[1] >= 7 && horas[1] <= 13 ) { 
                            return 'M';
                        }

                        if ( horas[0] >= 13 && horas[0] <= 19 && horas[1] >= 13 && horas[1] <= 19 ) { 
                            return 'T';
                        }

                        if ( horas[0] >= 7 && horas[0] <= 13 && horas[1] >= 13 && horas[1] <= 19 ) { 
                            return 'MT';
                        }

                        if ( horas[0] >= 19 ) { 
                            return 'N';
                        }
                        
                    }

                    return horario;
                })
                .join('/');

            return horario;
        },

        lista_alocacoes_por_usuario (agendas) { 
            return _.groupBy(agendas.flatMap(agd => { 
                return agd.alocacao.map(aloc => { 
                    return { 
                        ...aloc,
                        horario: agd.hr_inicio.substr(0,2) + '-' + agd.hr_termino.substr(0,2),
                    };
                });
            }), 'usuario.search');
        },

        abrir_repeticao (alocacao) { 
            this.$refs.repet.abrir(alocacao.id_plantao_repeticao, alocacao.id_plantao_escala);
        },

        cancelar_escala (alocacao) { 
            this.validate = false;
            this.motivo = "";
            this.item_cancelar = _.cloneDeep(alocacao);
            
            $('#cancelarEscalaModal').modal('show');
        },

        salvar_cancelamento_escala () { 
            this.$util.atualizar (this, { 
                service: 'plantao_escalas',
                func: 'cancelar_escala',
                dados: { 
                    id_plantao_escala: this.item_cancelar.id_plantao_escala, 
                    motivo: this.motivo, 
                },
                toast: true, 
                modal: 'cancelarEscalaModal',
                reload: true, 
            });
        },

        editar_troca (plantao, agenda) { 
            this.$refs.troca.editar(plantao, agenda);
        },

        trocar (plantao, agenda) { 
            this.$refs.troca.trocar(plantao, agenda);
        },

        editar_venda (plantao, agenda) { 
            this.$refs.venda.editar(plantao, agenda);
        },

        vender (plantao, agenda) { 
            this.$refs.venda.vender(plantao, agenda);
        },

        consultar_alocados (item) { 
            this.alocados = _.cloneDeep(item);

            $('#alocadosModal').modal('show');
        },

        calc_datas() { 

            if ( !this.item )
                return [];

            let contador = 0;
            let base = this.filtro.referencia;
            let lista = [];

            if ( !base )
                return [];

            if ( this.item.repeticao == 'N' ) { 
                return [
                    base
                ];
            }

            if ( this.item.repeticao == 'I' || this.item.js_dias_da_semana[moment(base, "YYYY-MM-DD").weekday()] ) { 
                lista.push(base);
            }

            if ( this.item.repetir.fim == 'em' ) { 

                while ( base < this.item.repetir.termina_em && contador < 40 ) { 

                    if ( this.item.repeticao == 'I' ) { 

                        base = moment(base, "YYYY-MM-DD").add(this.item.repetir.intervalo ? this.item.repetir.intervalo : 1,"day").format('YYYY-MM-DD');    
                        lista.push(base);

                    } else { 

                        base = moment(base, "YYYY-MM-DD").add(1,"day").format('YYYY-MM-DD');

                        if ( this.item.js_dias_da_semana[moment(base, "YYYY-MM-DD").weekday()] ) { 

                            if ( !(this.semana(this.dados.base, base) % this.item.repetir.intervalo ) ) {
                                lista.push(base);
                            }

                        }

                    }

                    contador ++;

                }

                this.item.repetir.ocorrencias = lista.filter(item => { 
                    return !this.dados.valid || this.dados.valid[item] == 'S';
                }).length;

            } else if ( this.item.repetir.fim == 'apos' ) { 

                let ocorrencias = ( this.item.repetir.ocorrencias > 32 ? 31 : this.item.repetir.ocorrencias - 1 );

                if ( !lista.length )
                    ocorrencias ++;

                while ( ocorrencias > 0 && contador < 1000  ) { 

                    if ( this.item.repeticao == 'I' ) { 

                        base = moment(base, "YYYY-MM-DD").add(this.item.repetir.intervalo ? this.item.repetir.intervalo : 1,"day").format('YYYY-MM-DD');    

                        lista.push(base);
                        ocorrencias --;

                    } else { 

                        base = moment(base, "YYYY-MM-DD").add(1,"day").format('YYYY-MM-DD');

                        if ( this.item.js_dias_da_semana[moment(base, "YYYY-MM-DD").weekday()] ) { 
                            lista.push(base);

                            ocorrencias --;

                            /*
                            if ( !this.dados.valid || ( this.dados.valid[base] !== 'N' && this.dados.valid[base] !== 'B' ) ) 
                                ocorrencias --;
                            */
                        }

                    }

                    contador ++;
                }

                this.item.repetir.termina_em = base;

            }

            return lista;

        },

        semana(from, to) { 
            from = moment(from, 'YYYY-MM-DD');
            to = moment(to, 'YYYY-MM-DD');
            return to.diff(from, 'weeks');
        },

        mensal_alocacao_data(semana, dia) { 
            //console.log('L', this.lista);
            //console.log(semana, _.flatMap(this.lista, item => item.dias[semana][dia]));

            return _.flatMap(this.lista, item => item.dias[semana][dia]);
        },

        incluir_usuario () { 
            if ( !this.novo_usuario )
                return;

            let novo = _.cloneDeep(this.novo_usuario);
            novo.excluido = false;

            this.novo_usuario = null;

            this.$nextTick(() => { 
                this.item.usuarios.push(novo);
                this.novo_usuario = "";
            });
        },

        atualizar_tipo () { 
            let lista = this.$store.state.options['plantao_tipos.index'];

            if ( lista ) { 
                this.item.tipo = lista.find(pt => pt.id_plantao_tipo == this.item.id_plantao_tipo);

                if ( this.item.tipo && !this.item.id_plantao_agenda ) { 
                    this.trocando_valor = true; 

                    this.$nextTick(() => { 
                        // this.item.dc_valor_plantao = this.item.tipo.dc_valor_plantao;
                        this.item.js_classes = this.item.tipo.js_classes;
                        this.trocando_valor = false; 
                    });
                }
            }
        },

        toggle_dia(dia) { 
            this.$set(this.item.js_dias_da_semana, dia, !this.item.js_dias_da_semana[dia]);
        },
        
        nome_dia(dia) { 
            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sab';
            }

            return '?';
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        alocar(agenda) { 
            this.novo_usuario = "";

            this.item = { 
                usuarios: [], 
                repeticao: 'N',
                id_plantao_agenda: agenda.id_plantao_agenda, 
                referencia: this.filtro.referencia, 
                js_dias_da_semana: agenda.js_dias_da_semana.map((dia, wd) => dia 
                    ? ( moment(this.filtro.referencia, "YYYY-MM-DD").weekday() == wd )  
                    : null),
                repetir: { 
                    intervalo: 1, 
                    termina_em: "", 
                    fim: "em",
                    ocorrencias: 1, 
                },
            };

            this.agenda = _.cloneDeep(agenda);

            $('#alocacaoModal').modal('show');
        },

        salvar_alocacao() { 
            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'alocar',
                dados: { 
                    ...this.item,
                    datas: this.calc_datas(),
                },
                reload: true, 
                modal: 'alocacaoModal',
            });
        },
        
        incluir () { 
            this.validate = false;
            
            let item = {
                id_plantao_agenda: null, 
                id_unidade_operacao: "", 
                id_plantao_tipo: "", 
                id_centro_cirurgico: "", 
                js_dias_da_semana: [true,true,true,true,true,true,true],
                dc_valor_plantao: null, 
                fl_ativo: true,
                js_classes: [],
                dt_vigencia_inicio: this.$util.hoje(), 
                dt_vigencia_fim: this.$util.hoje(),
                hr_inicio: null,
                hr_termino: null, 
                st_obs: "", 
            };

            this.editar (item);
        },
        load () { 
            let filtro = _.cloneDeep(this.filtro);

            this.$util.load(this, { 
                service:'plantao_agendas',
                func: 'index',
                parms: { 
                    alocacao: true, 
                    ...this.filtro,
                },
                loadTo: res => { 
                    this.base = _.cloneDeep(this.filtro);
                    this.dados = res;
                    this.filtro_selecionado = filtro;
                }
            });

            this.$refs.mov.load();
        },
        editar (item) { 
            if ( item.gestao_escalas === false ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Acesso disponível somente para o gestor de escalas. (#107)',
                    life: 5000
                });  
                return;
            }

            this.validate = false;
            this.item = null;

            this.$nextTick(() => { 
                this.item = _.cloneDeep (item);
        
                $('#edicaoModal').modal('show');
            });
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'plantao_agendas',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'plantao_agendas',
                dados: item,
            });

        },
    },

    mounted () { 
        // this.load ();

        this.breadcrumb = [
                { name: "Escalas", path: "/escalas/escalas"},
                { name: "Alocacao", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, { 
            service: 'usuarios',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>